var map = {
	"./00000212.jpg": 299,
	"./Green_tick.png": 219,
	"./Keypoints.png": 300,
	"./Posenet model.png": 301,
	"./Shirshasana.png": 302,
	"./Tree.jpg": 303,
	"./a.jpg": 304,
	"./boy.jpg": 305,
	"./cardchairpose.jpg": 306,
	"./cardgoddess.jpg": 307,
	"./cardmeditation.jpg": 308,
	"./cardplank.webp": 309,
	"./cardsurya.jpg": 310,
	"./cardtadasana.jpg": 311,
	"./cardtree.jpg": 312,
	"./cardwarrior.jpg": 313,
	"./cross.png": 220,
	"./crossed.webp": 314,
	"./forward-bend.webp": 315,
	"./goddess.jpg": 316,
	"./hand.jpg": 317,
	"./handraise.jpg": 318,
	"./load.jpg": 319,
	"./loading.png": 320,
	"./loading.svg": 221,
	"./man.jpg": 321,
	"./meditation.jpg": 322,
	"./plank.png": 323,
	"./sirsasana.jpg": 324,
	"./sit.jpg": 325,
	"./sitting.webp": 326,
	"./squat.jpg": 327,
	"./suryanamskar.jpg": 328,
	"./tadasana.jpg": 329,
	"./tree (2).jpg": 330,
	"./warrior.jpg": 331,
	"./yoga.jpg": 332
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 218;